import { ReactNode } from "react";
import { useRouter } from "next/router";
import { Security } from "@okta/okta-react";
import OktaAuth, { toRelativeUrl } from "@okta/okta-auth-js";

import { global_config } from "src/shared/global_config";

type Props = {
  children: ReactNode;
};

export function useOktaHelper() {
  const router = useRouter();
  const { OKTA, FRONTEND_URL } = global_config;

  const frontendUrl = FRONTEND_URL; // prettier-ignore
  const redirectUri = `${frontendUrl}/mlbcallback`;

  function handleGetOktaAuthClient() {
    if (router?.query?.teamSchema === "mlb_pass") {
      return new OktaAuth({
        issuer: "https://qa-ids.mlb.com/oauth2/ausg0y0s07iKGqVKv0h7",
        clientId: "0oa1nin07jvpyEYHU0h8",
        redirectUri,
        postLogoutRedirectUri: frontendUrl,
      });
    }

    return new OktaAuth({
      issuer: OKTA.ISSUER,
      clientId: OKTA.CLIENT_ID,
      redirectUri,
      postLogoutRedirectUri: frontendUrl,
    });
  }

  async function handlePostOktaAuth(client: OktaAuth) {
    await client.handleRedirect();
    let idToken = (await client.tokenManager.get("idToken")) as any;
    let email = idToken?.claims?.email as string;
    return { email };
  }

  async function restoreOriginalUri(oktaAuth: OktaAuth, originalUri: string) {
    await router.replace(toRelativeUrl(originalUri || "/", FRONTEND_URL));
  }

  return { restoreOriginalUri, handlePostOktaAuth, handleGetOktaAuthClient };
}

export function OktaProvider({ children }: Props) {
  const { restoreOriginalUri, handleGetOktaAuthClient } = useOktaHelper();

  return (
    <Security
      oktaAuth={handleGetOktaAuthClient()}
      restoreOriginalUri={restoreOriginalUri}
    >
      {children}
    </Security>
  );
}
